import React from 'react';

import IMG_OFFLINE from 'assets/images/pos/reader-offline.png';
import Space from 'components/generic/Space.component';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';

import CN from './MessageOffline.module.scss';

const MessageOffline = () => {
  const { t } = useTranslation();
  return (
    <div data-bem="MessageOffline">
      <div>
        <img src={IMG_OFFLINE} alt="POS reader with a red X over it" className={CN.image} />
      </div>

      <div className={CN.title}>{t('composite.posMessages.offlineTitle')}</div>
      <div className={CN.subTitle}>
        {t('composite.posMessages.offlineSubtitlePart1')}
        {S.space}
        <span className={CN.highlight}>{t('composite.posMessages.offlineSubtitlePart2')}</span>
        {t('composite.posMessages.offlineSubtitlePart3')}
        <Space>
          <span className={CN.highlight}>{t('composite.posMessages.offlineSubtitlePart4')}</span>
        </Space>
        {t('composite.posMessages.offlineSubtitlePart5')}
        <Space>
          <span className={CN.highlight}>{t('composite.posMessages.offlineSubtitlePart6')}</span>
        </Space>
        {t('composite.posMessages.offlineSubtitlePart7')}
      </div>
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default MessageOffline;
